import { useEffect, useRef, useState } from 'react';
import { ArrowRight, X } from 'lucide-react';
import { Dialog, DialogClose, DialogContent } from '../components/ui/dialog';
import Newsletter from '../components/newsLetter';
import { useItemsPerView } from '../hooks/useItemsPerView';
import '../../src/App.css';

const Team = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [selectedMember, setSelectedMember] = useState<any>(null);
  const [autoScrollDirection, setAutoScrollDirection] = useState<'right' | 'left'>('right');
  const autoScrollInterval = useRef<NodeJS.Timeout | null>(null);

  const teamMembers = [
    {
      name: "Victor Samuel",
      title: "Co-Founder & CEO",
      image: "/victor-samuels.png",
      bio: ["Victor Samuel is Founder and CEO of NV Global. He has over 20 years of regulatory and executive management experience, gained in senior compliance and operational roles with leading financial services companies and global consultancies. Victor is experienced in managing and leading complex AML and regulatory engagements and building out compliance management systems for financial institutions. His experience includes representing his client’s interests with the various regulators, including the state banking authorities, OCC, FINRA, SEC, CFTC and the CFPB.", "Victor is a senior advisor to banks, broker-dealers and fintech startups, where he advises senior management of client firms on how to successfully navigate regulatory challenges, conduct risk assessments of compliance, advise on suitability of new products and remediate and optimize compliance management systems. He is currently working on multiple projects in blockchain and crypto-assets with fintech startups such as: a major neo-bank, a cryptocurrency trading exchange, a crypto trading alerting tool, AML startup that provides KYC on the blockchain for ICOs and conducting a white paper review for a startup focused on ICO governance structure. Victor has served as a CCO for various retail full-service broker-dealers and has created sales practices and compliance programs across asset classes and covering all three lines of defense. He founded a retail broker-dealer which was acquired by a venture capital firm. He was successfully licensed as a Series 7,24,63 & 55 with multiple broker-dealers.", "Victor is a founding member of the International RegTech Association (IRTA). He completed the Fintech Innovation program from MIT and is a frequent and sought-after speaker at blockchain and cryptocurrency conferences on the implications of AML and regulatory compliance for blockchain and cryptocurrency. Victor has been a featured speaker at industry events, including the ABA Regulatory Conference, AML Actimize Conference, expert panelist for AML and Sanctions Programs at the Institute of International Banks (IIB), AML and OFAC best practices lecturer at the annual conference for the Institute of Internal Auditors (IIA), and the Credit and Collections Conference, as a subject matter expert on compliance management and control environments in financial institutions. He is also an associate professor for regulatory compliance and blockchain/crypto at Case Western Reserve School of Law.", "Victor received his Juris Doctor from Brooklyn Law School with a concentration in securities law and is admitted to the bar in New York State. He received his MBA in Finance & Investments from Baruch College and graduated from Hunter College with a Bachelor of Arts in political science and comparative literature."],
      linkedIn: "https://www.linkedin.com/in/victor-t-samuel-4a42486",
      twitter: "https://x.com/victortsamuel",
      telegram: "https://t.me/Victorsamuel"
    },
    // {
    //   name: "Charles Lansdown",
    //   title: "Managing Consultant",
    //   image: "/charles-lansdown.png",
    //   bio: [ "Charles Lansdown is a Managing Consultant for Commercial Real Estate Finance and Corporate Banking at NV Global. He has over 30 years of executive management experience, gained in senior credit and lending roles in the US market with leading international banks. Charles has an extensive background in loan origination, senior / subordinated debt structuring, loan syndication, construction and bridge loans, portfolio management, debt restructuring and loan workouts.","As the Executive Vice President and General Manager of the New York branch of a German bank with assets in excess of $300 billion, Charles was responsible for the management of US assets in excess of $12 billion including a $9 billion portfolio of commercial real estate loans in these classes – office, retail, multifamily, hospitality and senior housing. With a personal credit authority of up to $100 million, Charles was also engaged in project financings that included the construction of more US wind power and solar power generation facilities than any other bank globally.", "Charles has acted on behalf of several European banks to start subsidiaries and banking offices in the United States and Canada. He is experienced in dealing with officials of the state banking departments in New York, New Jersey, California and Utah as well as officers of the Federal Reserve Bank of New York, the Federal Reserve Board in Washington, the Office of the Comptroller of the Currency and the Federal Deposit Insurance Corporation. When managing a bank branch, a bank representative office and other financial entities, Charles also maintained relationships with banking regulators in Finland, Sweden, Germany and Canada.", "Charles holds FINRA licenses Series 7, 24, 63 and 65. He is a Certified Anti-Money Laundering Specialist and a member of the Association of Certified Anti-Money Laundering Specialists and the Association of International Bank Audit and Compliance Professionals. Charles received his Master of Business Administration with Distinction with a concentration in Finance from the Center for Business Management at the New York Institute of Technology. He received his Bachelor of Arts in English Literature and Certificate in Medieval Studies from Binghamton University." ]
    // },
    // {
    //   name: "Puja Samuel",
    //   title: "Chief Operating Officer",
    //   image: "/puja-samuels.png",
    //   bio: [ "Puja is a financial services professional with over 17 years of industry experience. Her experience stems from firms such as JP Morgan, Digital Currency Group (DCG), Citi, New York Life, Hertz and McKinsey. Puja has held various roles throughout her career including, Head of Client Success, Head of Corporate Development, Head of Ideation, and Head of External Innovation. She is well versed in strategy, innovation, client solutions, execution, product / program / project management, business operations and establishing partnerships.", "Puja has successfully designed and established innovation programs for JP Morgan, New York Life Ventures and Citi Ventures. She has expertise in designing and implementing strategic growth initiatives, developing corporate and digital strategies, fostering commercial opportunities with startups, and new product development. She has managed the process of new venture creation by vetting business ideas and problem statements, and managing growth portfolios for key internal business and functional partners. Puja also has experience compliance and regulatory experience derived from her experience working for the Global Compliance Architecture group and the office of the Chief Compliance Officer at Citi. Prior to Citigroup she was at SBLI USA Mutual Life Insurance Company where she reported directly to the CEO and managed the strategic and operational planning process. She has also worked for Hertz and McKinsey & Company conducting market research and developing growth strategies. Puja also brings experience with digital assets, crypto and the metaverse from her time at JP Morgan and DCG.", "She is the recipient of the 2020 Inspiring Female Leaders awarded by the NYC FinTech Women organization to connect, empower, and promote women to strengthen the ecosystem.", "Puja earned her BS in Finance and Marketing from Fordham University and completed a fintech certification program with MIT." ],
    //   linkedIn: "https://www.linkedin.com/in/puja-77b9802",
    //   twitter: "https://x.com/pujasamuel",
    //   telegram: "https://t.me/pujasamuel"
    // },
    {
      name: "Sirbuland Atlas",
      title: "CTO in Residence",
      image: "/sirbuland-atlas.png",
      bio: [ "Driving Innovation | Leading Scalable Tech Solutions | Empowering Engineering Teams", "As Chief Technology Officer at NV Global, Sirbuland brings a vision-driven approach to building high-performance technology ecosystems. With over 15 years of experience in software architecture, engineering leadership, and emerging technologies, he leads the company's technology strategy, ensuring every solution is robust, scalable, and future-ready.", "Sirbuland is passionate about leveraging cutting-edge innovations—ranging from AI and cloud computing to automation and DevOps—to accelerate digital transformation for NV Global's fintech vision. A firm believer in collaborative leadership, he mentors diverse engineering teams, promotes agile development practices, and fosters a culture of continuous improvement." ],
      linkedIn: "https://www.linkedin.com/in/sirbuland-atlas-1a384529a",
      twitter: "",
      telegram: ""
    },
    {
      name: "Sandra Clarke",
      title: "Managing Consultant",
      image: "/sandra-clarke.png",
      bio: [ "Sandra Clarke, Chief Compliance Officer at Adelphi Stock Brokers Inc. is responsible for overseeing the Firm's comprehensive compliance infrastructure. She also serves as the Managing Director of Consultants at NV Global Ventures, where she leads operations and advises a team of professional consultants who support broker-dealers, investment advisers, and digital asset firms.", "Sandra brings over 33 years of regulatory and compliance experience in the securities industry. Prior to joining Adelphi and NV Global, Sandra, spent more than three decades at FINRA, where she held numerous leadership roles across three key areas of FINRA Regulatory & Membership Supervision Program.", "Specifically, Sandra worked in FINRA's Membership Application Program and held various positions including, Examiner, Manager, and Associate Director. In her most recent role as Associate Director, Sandra oversaw new membership and continuing membership applications for broker-dealers, funding portals, and certain exchanges governed under Regulatory Service Agreements with FINRA." ],
      linkedIn: "https://www.linkedin.com/in/sandra-clarke-5296a492",
      twitter: "",
      telegram: ""
    },
    {
      name: "Don Pollard",
      title: "Managing Consultant",
      image: "/don-pollard.png",
      bio: [ "An accomplished financial services executive with over 25 years of industry experience, Don played a pivotal role in the creation of Quick & Reilly's groundbreaking online trading platform—one of the first of its kind. He was equally instrumental in developing the firm's foundational compliance framework for digital trading, helping to set industry standards during a transformative era." , "A graduate of St. Joseph's College with a degree in business, Don has held senior management positions at leading firms including E*TRADE, Oppenheimer, and Smith Barney. His expertise spans broker-dealer operations, regulatory strategy, and capital markets infrastructure.", "Don is FINRA-licensed with Series 24, 7, 63, 4, and 8 certifications, and is widely recognized for bridging innovation with regulatory integrity."],
      linkedIn: "https://www.linkedin.com/in/don-pollard-9729615",
      twitter: "",
      telegram: ""
    },
    {
      name: "James Falvey",
      title: "Managing Consultant",
      image: "/james-falvey.png",
      bio: [ "Jim is the Managing Consultant for Swaps, Futures, and Derivatives at NV Global. He has over 5 years of experience working with cryptocurrencies, ICOs, and blockchain initiatives. Jim is General Counsel for EverMarkets (“EMX”), a crypto derivatives exchange and also a Co-Founder and General Counsel for the Intellectual Property Coin Group (“IPCG”).", "His prior experience includes serving as General Counsel for Ocean Tomo, Intercontinental Exchange (“ICE”), EurexUS, RJ O’Brien, and Green Key Technologies. He also has experience as the Chief Administrative Officer for the U.S. Futures Exchange.", "Jim has worked in a number of government positions, including as a Legislative Assistant for U.S. Rep. Fred Upton, Law Clerk for U.S. District Court Judge Richard Enslen, and appointed member of the Technology Advisory Committee for the Commodity Futures Trading Commission.", "Jim speaks regularly at conferences, has been a guest on U.K.’s largest public radio station, has authored several articles, and has been quoted in various media outlets focused on the crypto world. He also teaches courses on derivatives and FinTech at the Chicago Kent School of Law and Commodity Market at Penn State University. Jim received his Juris Doctor from Georgetown University Law Center. He received his MBA from Northwestern Kellogg School of Management and his BA in Government from the University of Notre Dame." ],
      linkedIn: "https://www.linkedin.com/in/jimfalveyjdmba",
      twitter: "https://x.com/JimFalvey",
      telegram: ""
    },
    {
      name: "Crystal Ang",
      title: "Senior Consultant",
      image: "/crystal-ang.png",
      bio: [ "As a Senior Consultant at NV Global, Crystal Ang partners with clients across financial services with a focus on streamlining back-office operations to enable scalable growth in trading, custody, and client acquisition. She has expertise in capital markets, brokerage infrastructure, and emerging fintech solutions, Crystal brings a practical, client-first approach to every engagement.", "Crystal has a proven track record of helping firms optimize operational workflows, and scale with confidence. Whether supporting go-to-market execution or building internal operational capabilities, policies and procedures, Crystal plays a critical role in helping NV Global clients achieve lasting results in fast-evolving market environments." ],
      linkedIn: "https://www.linkedin.com/in/crystalang",
      twitter: "",
      telegram: ""
    }
  ];

  const itemsPerView = useItemsPerView();
  const maxIndex = Math.max(0, teamMembers.length - itemsPerView);

  const scrollLeft = () => {
    setCurrentIndex(Math.max(0, currentIndex - 1));
    resetAutoScroll();
  };

  const scrollRight = () => {
    setCurrentIndex(Math.min(maxIndex, currentIndex + 1));
    resetAutoScroll();
  };

  const startAutoScroll = () => {
    autoScrollInterval.current = setInterval(() => {
      setCurrentIndex(prevIndex => {
        if (autoScrollDirection === 'right') {
          if (prevIndex >= maxIndex) {
            setAutoScrollDirection('left');
            return prevIndex - 1;
          }
          return prevIndex + 1;
        } else {
          if (prevIndex <= 0) {
            setAutoScrollDirection('right');
            return prevIndex + 1;
          }
          return prevIndex - 1;
        }
      });
    }, 3000);
  };

  const resetAutoScroll = () => {
    if (autoScrollInterval.current) {
      clearInterval(autoScrollInterval.current);
    }
    startAutoScroll();
  };

  useEffect(() => {
    startAutoScroll();
    return () => {
      if (autoScrollInterval.current) {
        clearInterval(autoScrollInterval.current);
      }
    };
  }, [maxIndex, autoScrollDirection]);

  const openMemberModal = (member: any) => {
    setSelectedMember(member);
    if (autoScrollInterval.current) {
      clearInterval(autoScrollInterval.current);
    }
  };

  const closeMemberModal = () => {
    setSelectedMember(null);
    startAutoScroll();
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Main Content */}
      <main className="pt-16">
        {/* Hero Section */}
        <section className="px-4 sm:px-6 lg:px-8 py-12 md:py-20">
          <div className="flex flex-col md:flex-row justify-between items-start mb-12 md:mb-16 gap-6">
            <div className="max-w-full md:max-w-[75%]">
              <h1 className="font-light text-4xl md:text-[62.87px] leading-[100%] tracking-[0]">
                Our Team
              </h1>
              <h2 className="font-light text-4xl md:text-[62.87px] leading-[170%] tracking-[0] text-[#4A5664]">
                Passionate. Proactive. Expert.
              </h2>
              <p className="font-normal text-base md:text-[20px] leading-[160%] tracking-[0] text-[#4A5664] mt-4">
                Building effective teams require a combination of expertise and talent. We use our unique talent strategy to connect each project with the right experts from our trusted network of professionals.
              </p>
            </div>
            
            <div className="flex space-x-2 md:mt-auto w-full md:w-auto justify-end md:justify-normal">
              <button 
                onClick={scrollLeft}
                disabled={currentIndex === 0}
                className="w-10 h-10 md:w-12 md:h-12 border border-gray-300 flex items-center justify-center hover:bg-gray-50 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
              >
                <ArrowRight className="w-5 h-5 md:w-7 md:h-7 rotate-180" />
              </button>
              <button 
                onClick={scrollRight}
                disabled={currentIndex >= maxIndex}
                className="w-10 h-10 md:w-12 md:h-12 border border-gray-300 flex items-center justify-center hover:bg-gray-50 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
              >
                <ArrowRight className="w-5 h-5 md:w-7 md:h-7" />
              </button>
            </div>
          </div>

          {/* Team Grid */}
          <div className="overflow-hidden mb-12 md:mb-20">
            <div 
              className="flex transition-transform duration-300 ease-in-out"
              style={{ transform: `translateX(-${currentIndex * (100 / itemsPerView)}%)` }}
            >
              {teamMembers.map((member, index) => (
                <div 
                  key={index} 
                  style={{ width: `${100 / itemsPerView}%` }}
                  className="flex-shrink-0 px-2 md:px-4 group cursor-pointer"
                  onClick={() => openMemberModal(member)}
                >
                  <div className="aspect-[191/260] mb-4 md:mb-6 overflow-hidden">
                    <img 
                      src={member.image}
                      alt={member.name}
                      className="w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all duration-300"
                    />
                  </div>
                  <h3 className="text-lg md:text-xl font-medium text-black">{member.name}</h3>
                  <p className="text-sm md:text-base text-gray-600">{member.title}</p>
                </div>
              ))}
            </div>
          </div>
        </section>
        <Newsletter/>
      </main>

      {/* Team Member Modal */}
      <Dialog open={!!selectedMember} onOpenChange={closeMemberModal}>
        <DialogContent className="
          w-[80%] overflow-y-scroll
          lg:w-[70%] lg:overflow-y-auto
          max-w-2xl p-0 gap-0 bg-white
        ">
          <DialogClose className="absolute right-2 top-2 z-10 w-[40px] h-[40px] bg-black text-white flex items-center justify-center">
            <X className="h-4 w-4" />
            <span className="sr-only">Close</span>
          </DialogClose>
          
          {selectedMember && (
            <div className="flex flex-col lg:flex-row flex-col-reverse">
              {/* Image - Top on mobile, Left on desktop */}
              <div className="w-full lg:w-1/3 flex flex-col">
                {/* Image - takes 75% of the container height */}
                <div className="lg:flex-[3] overflow-hidden">
                  <img 
                    src={selectedMember.image}
                    alt={selectedMember.name}
                    className="w-full h-full object-cover"
                  />
                </div>
  
                {/* Social section - takes 25% of the container height */}
                <div className="h-[140px] lg:h-auto lg:flex-[1] bg-black flex items-center justify-center py-2 lg:py-0">
                  <div className='flex gap-2 lg:gap-[5px]'>
                    <a href={selectedMember?.linkedIn} target="_blank" rel="noopener noreferrer" 
                      onClick={(e) => {
                        if (!selectedMember?.linkedIn) e.preventDefault();
                      }}
                      >
                      <div className="h-10 w-10 lg:h-[51px] lg:w-[51px] bg-white flex items-center justify-center">
                        <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path fillRule="evenodd" clipRule="evenodd" d="M6.2862 4.92314H9.76384V6.6686H9.81417C10.2985 5.81797 11.4827 4.92314 13.2486 4.92314C16.9208 4.92314 17.6 7.16051 17.6 10.0711V16H13.9733V10.7443C13.9733 9.49138 13.9466 7.87854 12.0874 7.87854C10.1991 7.87854 9.90965 9.24239 9.90965 10.653V16H6.28617V4.92314H6.2862ZM3.77192 1.84626C3.77192 2.86542 2.9271 3.69252 1.88611 3.69252C0.845115 3.69252 0 2.86542 0 1.84626C0 0.827097 0.845115 0 1.88611 0C2.9271 0 3.77192 0.827097 3.77192 1.84626ZM0 4.92314H3.77192V16H0V4.92314Z" fill="black"/>
                        </svg>
                      </div>
                    </a>

                    <a href={selectedMember?.twitter} target="_blank" rel="noopener noreferrer" 
                      onClick={(e) => {
                        if (!selectedMember?.twitter) e.preventDefault();
                      }}
                      >
                      <div className="h-10 w-10 lg:h-[51px] lg:w-[51px] bg-white flex items-center justify-center">
                        <svg width="16" height="16.014" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16.014">
                          <path d="M9.524 6.782 15.481 0h-1.411l-5.175 5.887L4.765 0H0l6.247 8.903L0 16.014h1.411l5.462 -6.218 4.362 6.218H16M1.921 1.042h2.168l9.98 13.98h-2.169" fill="black"/>
                        </svg>
                      </div>
                    </a>

                    <a href={selectedMember?.telegram} target="_blank" rel="noopener noreferrer" 
                      onClick={(e) => {
                        if (!selectedMember?.telegram) e.preventDefault();
                      }}
                      >
                      <div className="h-10 w-10 lg:h-[51px] lg:w-[51px] bg-white flex items-center justify-center">
                        <svg width="20" height="20" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M2.77994 12.5923L18.1023 6.55035C19.214 6.11533 20.3016 7.20288 19.8666 8.3146L13.8246 23.637C13.3654 24.8212 11.6012 24.7487 11.2387 23.5161L9.81276 18.7067C9.71609 18.4167 9.76442 18.0784 9.98193 17.8125L13.7038 13.0273C13.7763 12.9548 13.7763 12.8098 13.6796 12.7131C13.6071 12.6406 13.4621 12.6406 13.3896 12.7131L8.60437 16.435C8.33852 16.6525 8.00018 16.7008 7.71016 16.6041L2.90077 15.1782C1.66822 14.8157 1.59572 13.0515 2.77994 12.5923Z" fill="black"/>
                        </svg>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
              
              {/* Content - Bottom on mobile, Right on desktop */}
              <div className="w-full lg:w-2/3 p-4 lg:p-8 bg-white">
                <h2 className="font-bold text-2xl lg:text-[29.24px] leading-[160%] tracking-[0]">
                  {selectedMember.name}
                </h2>
                <p className="font-normal text-base lg:text-[20px] leading-[160%] tracking-[0] text-[#4A5664]">
                  {selectedMember.title}
                </p>
                
                <div className="mt-4 lg:mt-[25px] lg:max-h-[50vh] lg:overflow-y-auto scrollbar-thin-grey">
                  {selectedMember.bio.map((paragraph: string, idx: number) => (
                    <p
                      key={idx}
                      className="font-normal text-sm lg:text-[19px] leading-[160%] tracking-[0] text-[#4A5664] mb-4"
                    >
                      {paragraph}
                    </p>
                  ))}
                </div>
              </div>
            </div>
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default Team;
